export default __webpack_public_path__ + "static/media/avatar_160.e9efb7bc.png";